import type {FC} from 'react'
import hrTemplatesData from '../../../data/hr/hrTemplatesData'
import {useParams} from 'react-router-dom'
import CombinedGeneration from '../../universal-components/combined-generation/CombinedGeneration'

interface HRTemplatePageProps {}

const HRTemplatePage: FC<HRTemplatePageProps> = () => {
  const {templateUrl} = useParams()
  const template: any = hrTemplatesData.templates.find((item: any) =>
    item.url.includes(templateUrl)
  )

  return <CombinedGeneration templateItem={template} />
}

export default HRTemplatePage
